import { checkResolution } from "Functions/helpers";
import "Layouts/default";
import 'Common/lightgallery';

import './form';

const mapEl = document.querySelector('.js-contact-map')

if (mapEl) {
    window.initContactMap = () => {
        const mapInstance = new google.maps.Map(mapEl, {
            center: new google.maps.LatLng(mapEl.dataset.lat, mapEl.dataset.lng),
            zoom: 14,
            clickableIcons: false,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false
        })

        if (!checkResolution('cxs;xs')) {
            mapInstance.panBy(document.querySelector('.js-contact-map-box').offsetWidth / 2 * -1 + 50, -70)
        }

        new google.maps.Marker({
            position: new google.maps.LatLng(mapEl.dataset.lat, mapEl.dataset.lng),
            icon: {
                path: 'M20 0C8.97208 0 0 8.88816 0 19.8129C0 33.5442 20.0197 57 20.0197 57C20.0197 57 40 32.8689 40 19.8129C40 8.88816 31.0283 0 20 0ZM26.0344 25.6142C24.3705 27.2622 22.1854 28.0863 20 28.0863C17.8149 28.0863 15.6291 27.2622 13.9659 25.6142C10.6385 22.3182 10.6385 16.9549 13.9659 13.6586C15.5772 12.0617 17.7205 11.1822 20 11.1822C22.2795 11.1822 24.4225 12.0621 26.0344 13.6586C29.3619 16.9549 29.3619 22.3182 26.0344 25.6142Z',
                fillColor: '#CF762C',
                fillOpacity: 1,
                strokeWeight: 0,
                rotation: 0,
                scale: 1,
                anchor: new google.maps.Point(20, 57),
            },
            map: mapInstance,
        })
    }

    if (window.customHasContactMapScriptInitialized) {
        window.initContactMap()
    }
}